import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { BaseProvider } from 'baseui';
import { theme } from './theme';
import Routes from './routes';
import * as serviceWorker from './serviceWorker';
import './theme/global.css';
import { SWRConfig } from "swr";
/* react-notification import  */
import 'animate.css';
import 'react-notifications-component/dist/theme.css'
import  {ReactNotifications}  from 'react-notifications-component'
import Notifications from './Notifications';

// import {io} from "socket.io-client";

// const client = new ApolloClient({
//   uri: process.env.REACT_APP_API_URL,
// });
 
import { messages } from './settings/site-translation/messages';

import { LanguageProvider } from './context/language/language.provider';



function App() {
  const engine = new Styletron();
  const MessengerRef = useRef();


  // Background notification polling - using setInterval instead of service worker
  // to avoid process.env not being available in worker context
  useEffect(() => {
    const interval = setInterval(() => {
      fetch(process.env.REACT_APP_API_URL + '/api/notifications/unseenNotifications?sort=-date')
        .then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .catch((error) => {
          console.error('Error fetching notifications:', error);
        });
    }, 10000);
    return () => clearInterval(interval);
  }, []);




  useEffect(() => {
    try {
      MessengerRef.current.setAttribute("page_id", "103120191131697");
      MessengerRef.current.setAttribute("attribution", "biz_inbox");

      window.fbAsyncInit = function () {
          FB.init({
              xfbml: true,
              version: 'v15.0'
          });
      };

      (function (d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
          js.onerror = function() { console.warn('Facebook SDK failed to load'); };
          fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    } catch (e) {
      console.warn('Facebook SDK initialization error:', e);
    }
  }, [])



//   const [show, setShow] = useState(false);
//   const [notification, setNotification]=useState({title:"",body:""});

//   onMessageListener()
//   .then((payload) => {
//      setNotification({
//        title: payload.notification.title,
//        body: payload.notification.body,
//      });
//   })
// .catch((err) => console.log("failed: ", err));
  //  const ENDPOINT = "http://localhost:5000"
  // React.useEffect(()=> {
  //   const socket = io(ENDPOINT) ; 
  //   socket.on("connect" , () => {console.log(socket.id)}); 
  //   socket.emit('chat message', 'bonjour tout le monde');
  //   return () => socket.disconnect();
  // },[])
  return (
    <SWRConfig value={{refreshInterval : 10000 }}>
    {/* <ApolloProvider client={client as any}> */}




    <LanguageProvider messages={messages}>
      <StyletronProvider value={engine}>
        <BaseProvider theme={theme}>

          <BrowserRouter>

          <ReactNotifications/>
          {/* <Notifications/> */}
            <Routes />
          </BrowserRouter>
          <div id="fb-root" style={{ display:"block" }} ></div>
          <div ref={MessengerRef} id="fb-customer-chat" className="fb-customerchat">
          </div>

        </BaseProvider>
      </StyletronProvider>
      </LanguageProvider>
    {/* </ApolloProvider> */}


    </SWRConfig>

  );
}

ReactDOM.render(<App />, document.getElementById('my_react_app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
